import register from '../../../../global/js/registry';
export default register('o-product-details', () => import(/* webpackMode: "lazy" */ './o-product-details.controller'));
